import * as React from "react";
import { MoneyDisplayHelper } from "../../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { FormComponent } from "../../../../../../../../react-core/Html/FormComponent";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { CurrencyCode } from "../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { Money } from "../../../../../../../../Wrap/Core/DataTypes/Money";
import { Typography } from "../../../../../../../Shared/Typography/Typography";
import { SectionHeader } from "../../../../AddClient/Components/SharedComponents";
import { FrequencyArraysMap } from "../../../../Common/Resource/Contents";
import { incomePaymentDetailsLabels } from "../../../Resource/Contents";
import { getAnnualIncomeBasedOnFrequency } from "../../../Resource/Helper";

interface IPaymentDetailsProps {
    data: any;
}

interface IPaymentDetailsState {}

export class PaymentDetails extends FormComponent<IPaymentDetailsProps, IPaymentDetailsState> {
    constructor(props: any) {
        super(props);
    }

    public render(): JSX.Element {
        const { data } = this.props;
        return (
            <>
                <h2 className="mt-48">Payment details</h2>
                <div className="row">
                    <span className="col-sm-6 h4">{incomePaymentDetailsLabels.totalPostRetirementAccountValue}</span>
                    <span className="col-sm-6 pl-0" data-test="clientage">
                        {this.getMoneyDisplay(data?.DrawdownIncomeAmendmentCalucations?.ValueUsedForReview)}
                    </span>
                </div>
                <div className="row">
                    <span className="col-sm-6 h4">{incomePaymentDetailsLabels.expectedGadMaximum}</span>
                    <span className="col-sm-6 pl-0" data-test="clientage">
                        {this.getMoneyDisplay(data?.DrawdownIncomeAmendmentCalucations?.ExpectedGadMaximum)}
                    </span>
                </div>
                {SectionHeader("Future pension year income")}
                <div className="row">
                    <div className="col-12 col-sm-fluid">
                        <h4>Before</h4>
                        <Typography
                            type={"auto-width"}
                            config={this.getValues(data?.DrawdownIncome?.AnnualIncome, true)}
                        />
                    </div>

                    <div className="col-12 col-sm-fluid">
                        <h4>After</h4>
                        <Typography
                            type={"auto-width"}
                            config={this.getValues(data?.DrawdownIncomeAmendmentInstruction?.Income, false)}
                        />
                    </div>
                </div>
            </>
        );
    }

    private getValues(data: any, isExistingValues: boolean) {
        const incomePerPayment = data?.TargetSpecificArrangements
            ? data?.GrossIncomePerPaymentFromPension
            : data?.GrossIncomePerPayment;
        const annualIncome = getAnnualIncomeBasedOnFrequency(incomePerPayment, data?.Frequency);
        return [
            { title: "Payment frequency", data: FrequencyArraysMap[data?.Frequency] },
            {
                title: isExistingValues ? "Next payment date" : "First payment date",
                data: JsonDateParser.getFormatDate(data?.NextPayment, "dd/MM/yyyy"),
            },
            {
                title: "Expected gross annual income",
                data: annualIncome?.Amount > 0 ? this.getMoneyDisplay(annualIncome) : null,
            },
        ];
    }

    private getMoneyDisplay(data: Money) {
        return MoneyDisplayHelper.FromatMoneyDisplay(data?.Amount, data?.Currency || CurrencyCode.GBP);
    }
}
